import React from "react";

type ErrorIllustrationProps = {
  className?: string;
};

const ErrorIllustration: React.FC<ErrorIllustrationProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 420 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <circle cx="210" cy="155" r="128" fill="#DDE8F4" />

      <ellipse cx="210" cy="248" rx="92" ry="10" fill="#C5D5E8" opacity="0.55" />

      <path
        d="M118 92C118 78.7452 128.745 68 142 68H188C201.255 68 212 78.7452 212 92V98H118V92Z"
        fill="#F4F7FB"
      />
      <circle cx="152" cy="88" r="5" fill="#B8C9DC" />
      <circle cx="168" cy="88" r="5" fill="#B8C9DC" />
      <path
        d="M136 104C136 96.268 142.268 90 150 90H180C187.732 90 194 96.268 194 104"
        stroke="#9DB3CB"
        strokeWidth="3"
        strokeLinecap="round"
      />

      <rect x="248" y="118" width="72" height="18" rx="4" fill="#EEF3F8" stroke="#B8C9DC" />
      <rect x="252" y="124" width="10" height="6" rx="2" fill="#9DB3CB" />
      <rect x="266" y="124" width="42" height="6" rx="2" fill="#C5D5E8" />

      <rect x="248" y="142" width="72" height="18" rx="4" fill="#EEF3F8" stroke="#B8C9DC" />
      <rect x="252" y="148" width="10" height="6" rx="2" fill="#9DB3CB" />
      <rect x="266" y="148" width="42" height="6" rx="2" fill="#C5D5E8" />

      <rect x="248" y="166" width="72" height="18" rx="4" fill="#EEF3F8" stroke="#B8C9DC" />
      <rect x="252" y="172" width="10" height="6" rx="2" fill="#9DB3CB" />
      <rect x="266" y="172" width="42" height="6" rx="2" fill="#C5D5E8" />

      <rect x="278" y="184" width="12" height="34" rx="2" fill="#B8C9DC" />

      <circle cx="284" cy="108" r="18" fill="#FF5A5F" />
      <rect x="280" y="98" width="8" height="14" rx="4" fill="white" />
      <circle cx="284" cy="116" r="2.5" fill="white" />

      <path
        d="M128 210H168L176 188H196L204 210H220"
        stroke="#7A96B5"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M142 188V176C142 168.82 147.82 163 155 163H181C188.18 163 194 168.82 194 176V188"
        stroke="#7A96B5"
        strokeWidth="3"
        strokeLinecap="round"
      />

      <path
        d="M118 210H228V218C228 222.418 224.418 226 220 226H126C121.582 226 118 222.418 118 218V210Z"
        fill="#4F86C6"
      />
      <path
        d="M126 226H222V236C222 240.418 218.418 244 214 244H134C129.582 244 126 240.418 126 236V226Z"
        fill="#3D74B5"
      />

      <path
        d="M150 132C150 124.82 155.82 119 163 119H173C180.18 119 186 124.82 186 132"
        stroke="#5E7896"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="168" cy="112" r="18" fill="#F7D3B0" />
      <path
        d="M150 112C150 100.954 158.954 92 170 92C181.046 92 190 100.954 190 112"
        fill="#3D4F63"
      />

      <path
        d="M198 146L206 138"
        stroke="#5E7896"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M136 146L128 138"
        stroke="#5E7896"
        strokeWidth="3"
        strokeLinecap="round"
      />

      <rect x="96" y="246" width="22" height="18" rx="4" fill="#D8B48A" />
      <path
        d="M107 246V232C107 226.477 111.477 222 117 222H131C136.523 222 141 226.477 141 232V246"
        fill="#8BC48A"
      />
      <ellipse cx="117" cy="228" rx="10" ry="12" fill="#6FB56E" />
      <ellipse cx="131" cy="228" rx="10" ry="12" fill="#6FB56E" />

      <path
        d="M88 118L96 110M96 118L88 110"
        stroke="#A9BBD0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M318 206L326 198M326 206L318 198"
        stroke="#A9BBD0"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ErrorIllustration;
